import User from '../interfaces/User';
import { canPerformAction, PERMISSIONS } from './permissions';

export function hasFullAgentAccess(user: User | null | undefined): boolean {
  if (!user) {
    return false;
  }
  if (user.permissions?.super_admin) {
    return true;
  }
  return canPerformAction(user, PERMISSIONS.MANAGE_AGENTS);
}

export function filterAgentsByUserAccess<T>(
  user: User | null | undefined,
  agents: T[],
  _accessibleRoleIds: string[]
): T[] {
  if (!user) {
    return [];
  }
  // Company agent lists are already filtered by visibility on the backend.
  return agents;
}

export function canUserAccessAgent(
  user: User | null | undefined,
  agent: { role_id?: string } | null | undefined,
  _accessibleRoleIds: string[]
): boolean {
  if (!user || !agent) {
    return false;
  }
  return hasFullAgentAccess(user);
}
